<template>
  <div class="page-wrap">
    <el-card class="filter-card" shadow="never">
      <el-form inline>
        <el-form-item label="处理状态">
          <el-select v-model="filterStatus" placeholder="全部" clearable style="width:120px" @change="onFilterChange">
            <el-option label="待处理" :value="0" />
            <el-option label="已处理" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadList">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column type="index" width="50" label="#" />
        <el-table-column prop="username" label="提交人" width="120" />
        <el-table-column label="来源" width="80">
          <template #default="{ row }">
            <el-tag size="mini" :type="row.submitterRole === 'STUDENT' ? 'info' : 'warning'">
              {{ row.submitterLabel || '教师' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="subjectName" label="学科/年级" width="100">
          <template #default="{ row }">{{ row.subjectName || row.gradeName || '—' }}</template>
        </el-table-column>
        <el-table-column prop="content" label="反馈内容" min-width="260" show-overflow-tooltip />
        <el-table-column label="截图" width="90">
          <template #default="{ row }">
            <span v-if="!(row.imageUrls && row.imageUrls.length)">—</span>
            <el-button v-else type="text" size="mini" @click="openDetail(row)">{{ row.imageUrls.length }} 张</el-button>
          </template>
        </el-table-column>
        <el-table-column label="管理员回复" min-width="180" show-overflow-tooltip>
          <template #default="{ row }">
            <span v-if="row.replyContent">{{ row.replyContent }}</span>
            <span v-else class="muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template #default="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'warning'" size="small">{{ row.statusLabel }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="170">
          <template #default="{ row }">{{ formatTime(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template #default="{ row }">
            <el-button type="text" size="mini" @click="openDetail(row)">查看</el-button>
            <el-button type="text" size="mini" class="primary-text" @click="openReply(row)">回复</el-button>
            <el-button
              v-if="row.status !== 1"
              type="text"
              size="mini"
              class="success-text"
              @click="markProcessed(row)"
            >标记已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        :total="total"
        layout="total, sizes, prev, pager, next"
      />
    </el-card>

    <el-dialog title="反馈详情" :visible.sync="detailVisible" width="720px">
      <template v-if="current">
        <p class="detail-meta">
          <span>{{ current.submitterLabel || '教师' }}：<b>{{ current.username }}</b></span>
          <span v-if="current.subjectName || current.gradeName"> · {{ current.subjectName || current.gradeName }}</span>
          <span> · {{ formatTime(current.createdAt) }}</span>
          <el-tag :type="current.status === 1 ? 'success' : 'warning'" size="mini" style="margin-left:8px">
            {{ current.statusLabel }}
          </el-tag>
        </p>
        <div class="detail-content">{{ current.content }}</div>
        <div v-if="current.imageUrls && current.imageUrls.length" class="detail-images">
          <el-image
            v-for="(url, i) in current.imageUrls"
            :key="i"
            :src="url"
            :preview-src-list="current.imageUrls"
            fit="contain"
            class="detail-img"
          />
        </div>
        <div v-if="current.replyContent" class="detail-reply">
          <div class="detail-reply-title">
            管理员回复
            <span v-if="current.replyByName">（{{ current.replyByName }}）</span>
            <span v-if="current.replyAt" class="reply-time"> · {{ formatTime(current.replyAt) }}</span>
          </div>
          <div class="detail-reply-body">{{ current.replyContent }}</div>
        </div>
      </template>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button type="primary" plain @click="openReply(current)">回复教师</el-button>
        <el-button
          v-if="current && current.status !== 1"
          type="primary"
          @click="markProcessed(current, true)"
        >标记已处理</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="replyForm.id ? '回复教师反馈' : '回复'" :visible.sync="replyVisible" width="560px" @closed="resetReplyForm">
      <p v-if="replyTarget" class="reply-quote">{{ replyTarget.content }}</p>
      <el-input
        v-model="replyForm.content"
        type="textarea"
        :rows="5"
        maxlength="2000"
        show-word-limit
        placeholder="请输入给教师的回复，提交后教师可在「问题反馈」中查看"
      />
      <span slot="footer">
        <el-button @click="replyVisible = false">取消</el-button>
        <el-button type="primary" :loading="replySaving" @click="submitReply">提交回复</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../utils/request'

export default {
  name: 'FeedbackList',
  data() {
    return {
      filterStatus: null,
      tableData: [],
      page: 0,
      size: 20,
      total: 0,
      loading: false,
      detailVisible: false,
      current: null,
      replyVisible: false,
      replySaving: false,
      replyTarget: null,
      replyForm: { id: null, content: '' }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = true
      const params = { page: this.page, size: this.size }
      if (this.filterStatus !== null && this.filterStatus !== '') {
        params.status = this.filterStatus
      }
      request.get('/feedback/list', { params }).then(data => {
        this.tableData = data.content || []
        this.total = data.totalElements || 0
      }).finally(() => { this.loading = false })
    },
    onFilterChange() {
      this.page = 0
      this.loadList()
    },
    handlePageChange(val) {
      this.page = val - 1
      this.loadList()
    },
    handleSizeChange(val) {
      this.size = val
      this.page = 0
      this.loadList()
    },
    formatTime(t) {
      if (!t) return '—'
      return String(t).replace('T', ' ').slice(0, 19)
    },
    openDetail(row) {
      this.current = row
      this.detailVisible = true
    },
    markProcessed(row, closeDialog) {
      this.$confirm('确认将该反馈标记为已处理？', '提示', { type: 'info' }).then(() => {
        request.put(`/feedback/${row.id}/processed`).then(() => {
          this.$message.success('已标记为已处理')
          if (closeDialog) this.detailVisible = false
          this.loadList()
        })
      }).catch(() => {})
    },
    openReply(row) {
      if (!row) return
      this.replyTarget = row
      this.replyForm = { id: row.id, content: row.replyContent || '' }
      this.replyVisible = true
    },
    resetReplyForm() {
      this.replyTarget = null
      this.replyForm = { id: null, content: '' }
    },
    submitReply() {
      if (!this.replyForm.content || !this.replyForm.content.trim()) {
        this.$message.warning('请填写回复内容')
        return
      }
      this.replySaving = true
      request.put(`/feedback/${this.replyForm.id}/reply`, {
        replyContent: this.replyForm.content.trim()
      }).then(() => {
        this.$message.success('回复已发送，教师可在问题反馈中查看')
        this.replyVisible = false
        this.detailVisible = false
        this.loadList()
      }).finally(() => { this.replySaving = false })
    }
  }
}
</script>

<style scoped>
.filter-card { margin-bottom: 12px; }
.pagination { margin-top: 16px; text-align: right; }
.success-text { color: #52c41a; }
.primary-text { color: #1677ff; }
.muted { color: #bbb; }
.detail-meta { margin: 0 0 12px; font-size: 13px; color: #666; }
.detail-content {
  white-space: pre-wrap;
  line-height: 1.7;
  font-size: 14px;
  color: #333;
  padding: 12px;
  background: #f7f9fc;
  border-radius: 6px;
  margin-bottom: 12px;
}
.detail-reply {
  margin-top: 16px;
  padding: 12px;
  background: #f0f9eb;
  border: 1px solid #d9f7be;
  border-radius: 6px;
}
.detail-reply-title { font-size: 13px; font-weight: 600; color: #389e0d; margin-bottom: 8px; }
.detail-reply-body { white-space: pre-wrap; line-height: 1.7; font-size: 14px; color: #333; }
.reply-time { font-weight: normal; color: #888; font-size: 12px; }
.reply-quote {
  margin: 0 0 12px;
  padding: 10px 12px;
  background: #f7f9fc;
  border-left: 3px solid #1677ff;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  max-height: 120px;
  overflow-y: auto;
}
.detail-images { display: flex; flex-wrap: wrap; gap: 12px; }
.detail-img { width: 200px; height: 140px; border: 1px solid #eee; border-radius: 4px; }
</style>
